import {Injectable} from '@angular/core';
import {Location} from '@angular/common';
import {SubtitlesService} from "./subtitles.service";
import {Language, LanguageShortcut} from "../models";


@Injectable({
    providedIn: 'root'
})
export class ForgotPasswordService {
    public url_id: string | undefined;
    url_lang: Language = ''

    constructor(
        private subtitles: SubtitlesService,
        private location: Location
    ) {
    }

    subtitle(id: number): string {
        return this.subtitles.setSubtitle(id);
    }

    getUrl() {
        const urlToArray = this.location.path().split(/[=&]/);

        if (urlToArray[1] !== undefined) {
            this.url_id = urlToArray[3];
            this.url_lang = urlToArray[1] as LanguageShortcut;
            if (this.url_lang !== this.subtitles.language) {
                this.subtitles.getSubtitles(this.url_lang);
            }
        }
    }
}

